import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { getRandomNumberString } from "~/userAnalytics";

type ErrorDetail = {
  category: string;
  message: string;
  field: string;
};

type ImageSearchCreationResponse = {
  statusCode: number;
  imageSearchId: string;
  validationErrors?: ErrorDetail[];
};

export async function requestImageSearch(
  image: Blob,
): Promise<Throwable<ImageSearchCreationResponse>> {
  // URL: /api/imagesearch/create POST
  // body:
  //  'imageFile', image
  //  'sessionId', random int

  const imageFile = new File([image], "image.jpg", {
    type: image.type,
  });
  const body = new FormData();
  body.append("imageFile", imageFile);
  body.append("sessionId", getRandomNumberString());
  const url = new URL(`/api/imagesearch/create`, window.location.origin);
  try {
    const response = await fetch(url.href, {
      method: "POST",
      body,
    });
    if (!response.ok) {
      throw new Error(
        `Fetch for /api/imagesearch/create failed with status ${response.status}`,
      );
    }
    const result = await response.json<ImageSearchCreationResponse>();
    return { isError: false, value: result };
  } catch (error) {
    return { isError: true, error: toError(error) };
  }
}
